import { TournamentState } from '@ps/web-poker-tile-mappers';

import type { Tournament, TournamentsData } from '../../types/MTT';
import { TILE_MAPPER_VERSION } from '../tileMappers';

const step2sng: Tournament = {
  __typename: 'Initial',
  id: 3806667895,
  isSnG: true,
  entrants: 11,
  legacyStatus: 384,
  prizePool: 1536,
  prizePoolValue: 1536,
  prizePoolUnit: 2,
  initStack: 500,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 1,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [25, 50],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 5,
  tournFlags2: 2147500033,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4734976,
  tournGroup: 224,
  whenStartInt: -1,
  regEndInt: -1,
  regStartInt: 1727696706,
  tournFlags: 1147143123,
  fee: 4,
  buyIn: 96,
  name: '<font color=#D6B25E>Power Path Step 2: $1 NLHE [Hyper-Turbo, 2x-Shootout], </font><font color=-x-tourn-guarantee>1 Ticket</font>',
  tournTypeName:
    '<font color=#D6B25E>Power Path Step 2 </font><font color=#525252>|</font><font color=#D6B25E> 2x-Shootout </font><font color=#525252>|</font><font color=-x-tourn-guarantee> 1 Ticket</font>',
  mobileName: '',
  pokerNgGroup: 'PATHSNG2',
  currency: 'USD',
  seats: 4,
  channels: ['STREAM51'],
  tournSpeed: 'HYPER',
  tournSpeedInt: 3,
  whenStart: '',
  maxPlayers: 16,
  minPlayers: 16,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '4-MAX',
      color: 'purple'
    },
    {
      title: 'Hyper',
      color: 'light-grey'
    },
    {
      title: 'SHOOTOUT',
      color: 'red'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathsng2_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathsng2_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName: 'Power Path Step 2 | 2x-Shootout | 1 Ticket',
  formattedSatelliteTargetName: '',
  formattedSidecarName: 'Power Path Step 2: $1 NLHE [Hyper-Turbo, 2x-Shootout], 1 Ticket',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.REGISTERING,
  formattedBuyIn: '$1',
  formattedPrizePool: '$15.36',
  shortPrizePool: '$15',
  formattedWinnerAward: '$0'
};

const step2tournament: Tournament = {
  __typename: 'Initial',
  id: 3732031330,
  isSnG: false,
  entrants: 0,
  legacyStatus: 384,
  prizePool: 50,
  prizePoolValue: 55000,
  prizePoolUnit: 5,
  initStack: 10000,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 0,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [15],
      blinds: [75, 150],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 1,
  tournFlags2: 2147500034,
  satelliteTarget: 3732031207,
  satelliteTargetNameMTT:
    '<font color=#D6B35E>Power Path Step 3 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>20 Seats Gtd</font><font color=#D6B35E> to $109 Step 4</b></font>',
  reEntryAllowed: 1,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735489,
  tournGroup: 225,
  whenStartInt: 1711850700,
  regEndInt: 1711851960,
  regStartInt: 0,
  tournFlags: 122166145,
  fee: 10,
  buyIn: 140,
  name: '<font color=#D6B35E>Power Path Step 2: $1.50 NLHE [Hyper-Turbo],</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=#D6B35E> to $11 Step 3</b></font>',
  tournTypeName:
    '<font color=#D6B35E>Power Path Step 2 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=#D6B35E> to $11 Step 3</b></font>',
  mobileName: 'Power Path Step 2',
  pokerNgGroup: 'PATHMTT2',
  currency: 'USD',
  seats: 8,
  channels: ['SATELLITES', 'STREAM29', 'STREAM50', 'ALL'],
  tournSpeed: 'HYPER',
  tournSpeedInt: 3,
  whenStart: '2024-03-31T02:05:00.000Z',
  maxPlayers: 5000,
  minPlayers: 52,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Hyper',
      color: 'light-grey'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    },
    {
      title: 'SAT',
      color: 'blue'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt2_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt2_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName: 'Power Path Step 2 | 50 Seats Gtd to $11 Step 3',
  formattedSatelliteTargetName: 'Power Path Step 3 | 20 Seats Gtd to $109 Step 4',
  formattedSidecarName: 'Power Path Step 2: $1.50 NLHE [Hyper-Turbo], 50 Seats Gtd to $11 Step 3',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.REGISTERING,
  formattedBuyIn: '$1.50',
  formattedPrizePool: '50 tickets',
  shortPrizePool: '50 tickets',
  formattedWinnerAward: '0 ticket'
};

const step3announced: Tournament = {
  __typename: 'Initial',
  id: 3732031146,
  isSnG: false,
  entrants: 2,
  legacyStatus: 0,
  prizePool: 2818600,
  prizePoolValue: 2818600,
  prizePoolUnit: 2,
  initStack: 10000,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 0,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [50, 100],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 5,
  tournFlags2: 2147500034,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735488,
  tournGroup: 227,
  whenStartInt: 1711911900,
  regEndInt: 1711914600,
  regStartInt: 0,
  tournFlags: 71308160,
  fee: 900,
  buyIn: 10000,
  name: '<font color=#D6B25E><b>Power Path Step 4: $109 Qualifier, </font><font color=-x-tourn-guarantee>2 Gold Passes Guaranteed!</font> - <font color=-x-tourn-live>Sunday Million Anniversary Edition</font></b>',
  tournTypeName:
    '<font color=#D6B25E><b>Power Path Step 4 Qualifier </font><font color=#525252>|</font><font color=#D6B25E> </font><font color=-x-tourn-guarantee>2 Gold Passes Guaranteed! </font><font color=#525252>|</font><font color=-x-tourn-live> Sunday Million Anniversary Edition</font></b>',
  mobileName: 'Power Path Step 4',
  pokerNgGroup: 'PATHMTT4',
  currency: 'USD',
  seats: 8,
  channels: ['SATELLITES', 'STREAM29', 'STREAM50', 'REGULAR', 'ALL'],
  tournSpeed: 'TURBO',
  tournSpeedInt: 2,
  whenStart: '2024-03-31T19:05:00.000Z',
  maxPlayers: 1000,
  minPlayers: 23,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Turbo',
      color: 'light-grey'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName:
    'Power Path Step 4 Qualifier | 2 Gold Passes Guaranteed! | Sunday Million Anniversary Edition',
  formattedSatelliteTargetName: '',
  formattedSidecarName:
    'Power Path Step 4: $109 Qualifier, 2 Gold Passes Guaranteed! - Sunday Million Anniversary Edition',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.ANNOUNCED,
  formattedBuyIn: '$109',
  formattedPrizePool: '$28,186',
  shortPrizePool: '$28.18K',
  formattedWinnerAward: '$0'
};

const step3registering: Tournament = {
  __typename: 'Initial',
  id: 3732031217,
  isSnG: false,
  entrants: 0,
  legacyStatus: 384,
  prizePool: 50,
  prizePoolValue: 545000,
  prizePoolUnit: 5,
  initStack: 10000,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 0,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [8],
      blinds: [40, 80],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 1,
  tournFlags2: 2147500034,
  satelliteTarget: 3732031147,
  satelliteTargetNameMTT:
    '<font color=#D6B25E><b>Power Path Step 4 Qualifier </font><font color=#525252>|</font><font color=#D6B25E> </font><font color=-x-tourn-guarantee>4 Silver Passes Guaranteed! </font><font color=#525252>|</font><font color=-x-tourn-live> Sunday Million Anniversary Edition</font></b>',
  reEntryAllowed: 1,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735489,
  tournGroup: 226,
  whenStartInt: 1711911900,
  regEndInt: 1711914600,
  regStartInt: 0,
  tournFlags: 122166145,
  fee: 73,
  buyIn: 1027,
  name: '<font color=#D6B35E>Power Path Step 3: $11 NLHE [Turbo],</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=#D6B35E> to $109 Step 4</b></font>',
  tournTypeName:
    '<font color=#D6B35E>Power Path Step 3 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=#D6B35E> to $109 Step 4</b></font>',
  mobileName: 'Power Path Step 3',
  pokerNgGroup: 'PATHMTT3',
  currency: 'USD',
  seats: 8,
  channels: ['SATELLITES', 'STREAM29', 'STREAM50', 'ALL'],
  tournSpeed: 'TURBO',
  tournSpeedInt: 2,
  whenStart: '2024-03-31T19:05:00.000Z',
  maxPlayers: 5000,
  minPlayers: 54,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Turbo',
      color: 'light-grey'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    },
    {
      title: 'SAT',
      color: 'blue'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt3_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt3_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName: 'Power Path Step 3 | 50 Seats Gtd to $109 Step 4',
  formattedSatelliteTargetName:
    'Power Path Step 4 Qualifier | 4 Silver Passes Guaranteed! | Sunday Million Anniversary Edition',
  formattedSidecarName: 'Power Path Step 3: $11 NLHE [Turbo], 50 Seats Gtd to $109 Step 4',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.REGISTERING,
  formattedBuyIn: '$11',
  formattedPrizePool: '50 tickets',
  shortPrizePool: '50 tickets',
  formattedWinnerAward: '0 ticket'
};

const step4announced: Tournament = {
  __typename: 'Initial',
  id: 3732031146,
  isSnG: false,
  entrants: 2,
  legacyStatus: 0,
  prizePool: 2818600,
  prizePoolValue: 2818600,
  prizePoolUnit: 2,
  initStack: 10000,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 0,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [50, 100],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 5,
  tournFlags2: 2147500034,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735488,
  tournGroup: 227,
  whenStartInt: 1711911900,
  regEndInt: 1711914600,
  regStartInt: 0,
  tournFlags: 71308160,
  fee: 900,
  buyIn: 10000,
  name: '<font color=#D6B25E><b>Power Path Step 4: $109 Qualifier, </font><font color=-x-tourn-guarantee>2 Gold Passes Guaranteed!</font> - <font color=-x-tourn-live>Sunday Million Anniversary Edition</font></b>',
  tournTypeName:
    '<font color=#D6B25E><b>Power Path Step 4 Qualifier </font><font color=#525252>|</font><font color=#D6B25E> </font><font color=-x-tourn-guarantee>2 Gold Passes Guaranteed! </font><font color=#525252>|</font><font color=-x-tourn-live> Sunday Million Anniversary Edition</font></b>',
  mobileName: 'Power Path Step 4',
  pokerNgGroup: 'PATHMTT4',
  currency: 'USD',
  seats: 8,
  channels: ['SATELLITES', 'STREAM29', 'STREAM50', 'REGULAR', 'ALL'],
  tournSpeed: 'TURBO',
  tournSpeedInt: 2,
  whenStart: '2024-03-31T19:05:00.000Z',
  maxPlayers: 1000,
  minPlayers: 23,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Turbo',
      color: 'light-grey'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName:
    'Power Path Step 4 Qualifier | 2 Gold Passes Guaranteed! | Sunday Million Anniversary Edition',
  formattedSatelliteTargetName: '',
  formattedSidecarName:
    'Power Path Step 4: $109 Qualifier, 2 Gold Passes Guaranteed! - Sunday Million Anniversary Edition',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.ANNOUNCED,
  formattedBuyIn: '$109',
  formattedPrizePool: '$28,186',
  shortPrizePool: '$28.18K',
  formattedWinnerAward: '$0'
};

const step4registering: Tournament = {
  __typename: 'Initial',
  isSnG: false,
  id: 3732031140,
  entrants: 1,
  legacyStatus: 384,
  prizePool: 1161700,
  prizePoolValue: 1161700,
  prizePoolUnit: 2,
  initStack: 10000,
  avgStack: 0,
  timeClosed: '',
  paidPlaces: 0,
  winner: '',
  winnerAward: 0,
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    structure: 3,
    hilo: 0,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [50, 100],
      stakes: [],
      bringIns: []
    }
  },
  isRestricted: false,
  awardSchema: 5,
  tournFlags2: 2147500034,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735488,
  tournGroup: 227,
  whenStartInt: 1711566300,
  regEndInt: 1711569000,
  regStartInt: 0,
  tournFlags: 71308160,
  fee: 900,
  buyIn: 10000,
  name: '<font color=#D6B25E><b>Power Path Step 4: $109 Qualifier, </font><font color=-x-tourn-guarantee>4 Silver Passes Guaranteed!</font> - <font color=-x-tourn-live>Sunday Million Anniversary Edition</font></b>',
  tournTypeName:
    '<font color=#D6B25E><b>Power Path Step 4 Qualifier </font><font color=#525252>|</font><font color=#D6B25E> </font><font color=-x-tourn-guarantee>4 Silver Passes Guaranteed! </font><font color=#525252>|</font><font color=-x-tourn-live> Sunday Million Anniversary Edition</font></b>',
  mobileName: 'Power Path Step 4',
  pokerNgGroup: 'PATHMTT4',
  currency: 'USD',
  seats: 8,
  channels: ['SATELLITES', 'STREAM29', 'STREAM50', 'REGULAR', 'ALL'],
  tournSpeed: 'TURBO',
  tournSpeedInt: 2,
  whenStart: '2024-03-27T19:05:00.000Z',
  maxPlayers: 1000,
  minPlayers: 17,
  game: 'HOLDEM',
  gameInt: 2,
  structure: 'NO_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isFlightTourn: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Turbo',
      color: 'light-grey'
    }
  ],
  imageUrl: 'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_wide.jpg',
  imageSquareUrl:
    'https://csapp.rationalcdn.com/pokerstars/ios/public/tiles/pkr_pathmtt4_square.jpg',
  fallbackImageUrl: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  formattedName:
    'Power Path Step 4 Qualifier | 4 Silver Passes Guaranteed! | Sunday Million Anniversary Edition',
  formattedSatelliteTargetName: '',
  formattedSidecarName:
    'Power Path Step 4: $109 Qualifier, 4 Silver Passes Guaranteed! - Sunday Million Anniversary Edition',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.REGISTERING,
  formattedBuyIn: '$109',
  formattedPrizePool: '$11,617',
  shortPrizePool: '$11.61K',
  formattedWinnerAward: '$0'
};

export const tournamentsData: TournamentsData = {
  [step2sng.id]: step2sng,
  [step2tournament.id]: step2tournament,
  [step3announced.id]: step3announced,
  [step3registering.id]: step3registering,
  [step4announced.id]: step4announced,
  [step4registering.id]: step4registering
};
